import { useContext, useState } from 'react'
import { __ } from '@wordpress/i18n'
import Button from '../Common/Button';
import Source from '../Common/Source';
import ModalContainer from '../Global/ModalContainer';
import AddSourceModal from './AddSourceModal';
import SbUtils from "../../Utils/SbUtils";
import FeedEditorContext from '../Context/FeedEditorContext';

const CustomizerSourcesModal = (props) => {
    const {
        upsellModal
    } = useContext(FeedEditorContext) || {};

    const [choosedSources, setChoosedSources] = useState(props.selectedSources);
    const [addSourcesModalActive, setAddSourcesModalActive] = useState(false);

    const disableAddSources = SbUtils.checkSourceLimitReached(props.selectedSources.length);
    const canCombineSources = SbUtils.canCombineSources();

    const selectSourceClick = (sourceId) => {
        // if multiple sources are allowed, then add the source to the list.
        if(canCombineSources) {
            const sSources = Object.values(choosedSources);
            if (!sSources.includes(sourceId)) {
                sSources.push(sourceId)
            } else {
                sSources.splice(sSources.indexOf(sourceId), 1);
            }
            setChoosedSources(sSources)
            return;
        } else {
            setChoosedSources([sourceId])
        }
    }

    return (
        <>
            {
                !addSourcesModalActive &&
                <div className='sb-feedsources-modal sb-fs'>
                    <div className='sb-feedsources-modal-content'>
                        <div className='sb-feedsources-modal-heading sb-fs'>
                            <h4 className='sb-h4'>{__('Add Sources', 'sb-customizer')}</h4>
                            <span className='sb-text-small sb-dark2-text'>{__('Select one or more sources you would like to add', 'sb-customizer')}</span>
                        </div>
                        <div className='sb-feedsources-modal-list sb-fs'>
                            <Button
                                text={__('Add New', 'sb-customizer')}
                                icon='plus'
                                customClass={`sb-addnew-source ${disableAddSources ? 'sb-btn-disabled' : ''}`}
                                boxshadow={false}
                                size='small'
                                iconSize='14'
                                onClick={() => {
                                    if (disableAddSources) {
                                        SbUtils.openUpsellModal('sourcesLimitModal', upsellModal)
                                    } else {
                                        setAddSourcesModalActive(true)
                                    }
                                }}
                            />
                            {
                                props.sources.sourcesList.map((source, sourceInd) => {
                                    const sourceInfo = source?.info !== '' && source?.info !== null && source?.info !== undefined ? JSON.parse(source?.info) : null;
                                    return (
                                        <Source
                                            key={sourceInd}
                                            checkbox={true}
                                            isChecked={choosedSources.includes(source.open_id)}
                                            name={source.display_name}
                                            openId={source.open_id}
                                            avatar={sourceInfo?.local_avatar_url || sourceInfo?.avatar_url}
                                            onClick={() => {
                                                selectSourceClick(source.open_id);
                                            }}
                                        />
                                    )
                                })
                            }
                        </div>

                        <div className='sb-feedsources-modal-btns sb-fs'>
                            <Button
                                size='medium'
                                type='secondary'
                                onClick={() => {
                                    props?.onCancel &&
                                        props.onCancel()
                                }}
                                text={__('Cancel', 'sb-customizer')}
                            />
                            <Button
                                icon='plus'
                                iconSize='12'
                                size='medium'
                                type='primary'
                                onClick={() => {
                                    props.onUpdateSources(choosedSources)
                                }}
                                text={__('Add', 'sb-customizer')}
                            />
                        </div>
                    </div>
                </div>
            }
            {
                addSourcesModalActive &&
                <ModalContainer
                    size='small'
                    closebutton={false}
                >
                    <AddSourceModal
                        openDialog={() => {
                            setAddSourcesModalActive(true)
                        }}
                    />
                </ModalContainer>
            }
        </>

    )
}


export default CustomizerSourcesModal;